import { render, staticRenderFns } from "./MovementBulkCreateUpdate.vue?vue&type=template&id=49f24e18&scoped=true&"
import script from "./MovementBulkCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./MovementBulkCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MovementBulkCreateUpdate.vue?vue&type=style&index=0&id=49f24e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f24e18",
  null
  
)

export default component.exports